<template>
  <section class="is-fluid">
    <div class="view-desktop">
      <div class="profile columns is-vcentered">
        <div class="is-one-fifth">
          <div class="image is-pulled-left">
            <img
              v-if="paciente.Avatar"
              :src="
                require(`../../../assets/images/avatars/${paciente.Avatar}.svg`)
              "
              alt=""
            />
            <img
              v-else
              :src="require(`../../../assets/images/avatars/31.svg`)"
              alt=""
            />
          </div>
        </div>
        <div class="title_column column">
          <h1 class="title is-pulled-left">Bem vindo, {{ paciente.Nome }}</h1>
          <p
            v-if="paciente.UltimoAtendimento"
            class="info_subtitle is-pulled-left"
          >
            Seu último atendimento foi em {{ paciente.UltimoAtendimento }}
          </p>
        </div>
        <div class="column">
          <router-link to="/editar-perfil" class="link is-pulled-right">
            <i class="icon-ic_edit" /> Editar dados cadastrais
          </router-link>
        </div>
      </div>
    </div>
    <div class="view-mobile">
      <div class="image">
        <img
          @click="showModal = true"
          v-if="paciente.Avatar"
          :src="
            require(`../../../assets/images/avatars/${paciente.Avatar}.svg`)
          "
          alt=""
        />
        <img
          v-else
          :src="require(`../../../assets/images/avatars/31.svg`)"
          alt=""
        />
      </div>

      <h1 class="title">Bem vindo, {{ paciente.Nome }}</h1>
      <p class="info_subtitle">
        Seu último atendimento foi em {{ paciente.UltimoAtendimento }}
      </p>
      <div class="link-container">
        <router-link to="/editar-perfil" class="link">
          <i class="icon-ic_edit" /> Editar dados cadastrais
        </router-link>
      </div>
    </div>
    <modal-template
      v-if="showModal"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h2>{{ $t('perfil.imagem-perfil') }}</h2>
      </template>
      <template #body>
        <vue-select-image
          :data-images="avatars"
          @onselectimage="onSelectImage"
        />
        <button class="button button-secondary" @click="changeAvatar">
          {{ $t('botoes.atualizar') }}
        </button>
      </template>
    </modal-template>
  </section>
</template>

<script>
import ModalTemplate from '@/components/shared/modal/ModalTemplate'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { NotAuthenticatedError } from '../../../models/not-authenticated-error'
import router from '@/router'

export default {
  name: 'Profile',
  computed: {
    ...mapGetters({
      avatars: 'getAvatars',
      paciente: 'dadosPaciente'
    })
  },
  data() {
    return {
      showModal: false
    }
  },
  components: {
    ModalTemplate
  },
  methods: {
    ...mapMutations(['SET_AVATAR']),
    ...mapActions(['atualizarAvatar']),
    toggleInfoModal() {
      this.showModal = !this.showModal
    },
    onSelectImage: function (data) {
      this.imageSelected = data
    },
    changeAvatar() {
      this.atualizarAvatar(this.imageSelected.id)
        .then(() => {
          this.SET_AVATAR(this.imageSelected.id)
          this.toggleInfoModal()
        })
        .catch((err) => {
          if (err instanceof NotAuthenticatedError) router.push('/')
        })
    }
  },
  created() {
    this.$store.dispatch('initAvatars')
  }
}
</script>

<style lang="scss" scoped src="@/assets/stylesheets/components/shared/profile/Profile.scss"></style>
